// Standard library imports
import React, { useContext, useEffect, useState } from 'react';

// Extenal library imports
import { UilSitemap } from '@iconscout/react-unicons'
import _ from 'lodash';

// Internal module imports
import CollapsibleWithRename from '../../../components/CollapsibleWithRename/CollapsibleWithRenameForGroup';

// Css imports
import classes from '../../../styles/DeviceList.module.css';

const DeviceList = ({ instances, sites, setSelectedInstance, updateQueryParams, queryParamsData }) => {
    const [collapsibleOpen, setCollapsibleOpen] = useState('');
    const [instanceGroupedBySite, setInstanceGroupedBySite] = useState({});

    useEffect(() => {
        const instanceGroupedBySiteHash = {};
        let collapsibleKey = '';

        instances.forEach((instance, idx) => {
            const siteKey = _.get(sites, instance.meta.groupId, 'Others');
            if (idx === 0) collapsibleKey = siteKey;
            const prev = _.get(instanceGroupedBySiteHash, siteKey, []);
            _.set(instanceGroupedBySiteHash, siteKey, prev.concat(instance));
        });
        setInstanceGroupedBySite(instanceGroupedBySiteHash);
        setCollapsibleOpen(collapsibleKey);
        setSelectedInstance(_.get(instanceGroupedBySiteHash, [collapsibleKey, 0], {}));
    }, [instances]);

    return (
        <div className={classes.Details}>
            <div></div>
            <div className={classes.CollapsibleContainer}>
                {Object.entries(instanceGroupedBySite).map(([site, values], idx) => {
                    return (<CollapsibleWithRename
                        open={collapsibleOpen}
                        setOpen={setCollapsibleOpen}
                        setCreateGroupModal={() => console.log("createGroupModal")}
                        group={values}
                        setDevice={setSelectedInstance}
                        deviceIcon={<UilSitemap size="1.2vw" style={{ color: 'var(--color-primary)' }} />}
                        title={site}
                    />)
                })}
            </div>
        </div>
    );
};

export default DeviceList;
